export const fiveMinutesMs = 1000 * 60 * 5;
export const twoMinutesMs = 1000 * 60 * 2;
